import React, { useEffect, useState, useRef } from "react";
import Header from "../Header/Hearder";
// import { FiSearch, FiBell, FiEdit } from "react-icons/fi";
import { MdOutlineMedicalServices } from "react-icons/md";
import { FaUserMd, FaUsers } from "react-icons/fa";
import "./Settings.css";
import axiosInstance from "../../lib/axiosInstance";
import { isAdminUser } from "../../lib/permissions";
import AdminStaffPanel from "./AdminStaffPanel";

function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result));
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function doctorPhotoUrl(d) {
  if (!d) return "";
  return (
    d.photoUrl ||
    d.profilePhotoUrl ||
    d.avatarUrl ||
    d.imageUrl ||
    (d.profileImage && (d.profileImage.url || d.profileImage)) ||
    ""
  );
}

const Settings = ({ user = null, branches = [], selectedBranchId = "", onBranchChange }) => {
  const [activeTab, setActiveTab] = useState("doctors");
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    specialty: "",
    licenseNumber: "",
    branchIds: [],
    isActive: true,
  });
  const doctorPhotoInputRef = useRef(null);
  const [doctorPhotoFile, setDoctorPhotoFile] = useState(null);
  const [doctorPhotoPreview, setDoctorPhotoPreview] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [editingBranchId, setEditingBranchId] = useState(null);
  const [branchError, setBranchError] = useState("");
  const [branchForm, setBranchForm] = useState({
    name: "",
    code: "",
    address: "",
    timezone: "Asia/Kolkata",
    isActive: true,
  });

  useEffect(() => {
    fetchDoctors();
    fetchBranches();
  }, []);

  useEffect(() => {
    if (!isAdminUser(user) && activeTab === "staff") {
      setActiveTab("doctors");
    }
  }, [user, activeTab]);

  async function fetchDoctors() {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/doctors", { params: { _ts: Date.now() } });
      const data = res && res.data ? res.data : res;
      setDoctors(data && data.items ? data.items : (Array.isArray(data) ? data : []));
    } catch (err) {
      console.error("fetch doctors error", err);
    } finally {
      setLoading(false);
    }
  }

  async function fetchBranches() {
    setBranchLoading(true);
    try {
      const res = await axiosInstance.get("/branches", { params: { page: 1, limit: 100, _ts: Date.now() } });
      const data = res && res.data ? res.data : res;
      setBranchList(data && data.items ? data.items : (Array.isArray(data) ? data : []));
    } catch (err) {
      console.error("fetch branches error", err);
      setBranchList([]);
    } finally {
      setBranchLoading(false);
    }
  }

  function clearDoctorPhoto() {
    if (doctorPhotoPreview && doctorPhotoPreview.startsWith("blob:")) {
      URL.revokeObjectURL(doctorPhotoPreview);
    }
    setDoctorPhotoFile(null);
    setDoctorPhotoPreview("");
    if (doctorPhotoInputRef.current) doctorPhotoInputRef.current.value = "";
  }

  function openCreate() {
    setEditingId(null);
    clearDoctorPhoto();
    setForm({
      name: "",
      email: "",
      phone: "",
      specialty: "",
      licenseNumber: "",
      branchIds: selectedBranchId ? [selectedBranchId] : [],
      isActive: true,
    });
    setError("");
    setShowModal(true);
  }

  async function openEdit(d) {
    const doctorId = d._id || d.id;
    let mappedBranchIds = selectedBranchId ? [selectedBranchId] : [];
    try {
      const mapRes = await axiosInstance.get("/doctor-branches", { params: { doctorId, isActive: true } });
      const mapData = mapRes && mapRes.data ? mapRes.data : mapRes;
      const maps = mapData && mapData.items ? mapData.items : (Array.isArray(mapData) ? mapData : []);
      const ids = maps
        .map((m) => m && m.branchId)
        .map((b) => (b && typeof b === "object" ? (b._id || b.id) : b))
        .filter(Boolean)
        .map((x) => String(x));
      if (ids.length) mappedBranchIds = ids;
    } catch (err) {
      // fallback to selectedBranchId if mapping fetch fails
    }
    clearDoctorPhoto();
    setEditingId(doctorId);
    setForm({
      name: d.name || "",
      email: d.email || "",
      phone: d.phone || "",
      specialty: Array.isArray(d.specialty) ? d.specialty.join(", ") : (d.specialty || ""),
      licenseNumber: d.licenseNumber || "",
      branchIds: mappedBranchIds,
      isActive: typeof d.isActive === "undefined" ? true : !!d.isActive,
    });
    const existing = doctorPhotoUrl(d);
    if (existing) setDoctorPhotoPreview(existing);
    setError("");
    setShowModal(true);
  }

  async function submitForm() {
    setError("");
    if (!form.name) {
      setError("Name is required");
      return;
    }
    if (!/^[A-Za-z ]+$/.test(String(form.name).trim())) {
      setError("Name should contain only letters and spaces");
      return;
    }
    if (!form.phone) {
      setError("Phone number is required");
      return;
    }
    if (!/^\d{10}$/.test(String(form.phone).trim())) {
      setError("Phone number must be exactly 10 digits");
      return;
    }
    if (!form.email) {
      setError("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(form.email).trim())) {
      setError("Please enter a valid email address");
      return;
    }
    if (!Array.isArray(form.branchIds) || form.branchIds.length === 0) {
      setError("Please select at least one branch");
      return;
    }
    const specialtyText = String(form.specialty || "").trim();
    if (specialtyText && !/^[A-Za-z ,]+$/.test(specialtyText)) {
      setError("Specialty should contain only letters, spaces, and commas");
      return;
    }
    const specialtyItems = specialtyText
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (specialtyItems.some((s) => !/^[A-Za-z ]+$/.test(s))) {
      setError("Each specialty should contain only letters and spaces");
      return;
    }
    try {
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        specialty: specialtyItems,
        licenseNumber: form.licenseNumber,
        isActive: !!form.isActive,
      };
      if (doctorPhotoFile) {
        payload.photoBase64 = await fileToDataUrl(doctorPhotoFile);
      }
      // Save doctor core profile first.
      let doctorId = editingId;
      if (editingId) {
        await axiosInstance.put(`/doctors/${editingId}`, payload);
      } else {
        const res = await axiosInstance.post("/doctors", payload);
        const data = res && res.data ? res.data : res;
        const doc = data && data.doctor ? data.doctor : data;
        doctorId = doc && (doc._id || doc.id) ? String(doc._id || doc.id) : null;
      }

      // Then sync doctor ↔ branches mapping (activate selected, deactivate removed).
      if (doctorId) {
        let existing = [];
        try {
          const mapRes = await axiosInstance.get("/doctor-branches", { params: { doctorId } });
          const mapData = mapRes && mapRes.data ? mapRes.data : mapRes;
          existing = mapData && mapData.items ? mapData.items : (Array.isArray(mapData) ? mapData : []);
        } catch (_) {
          existing = [];
        }

        const selected = (form.branchIds || []).map(String);
        const activeExisting = existing.filter((m) => m && m.isActive !== false);
        const toDeactivate = activeExisting.filter((m) => {
          const b = m.branchId;
          const bid = b && typeof b === "object" ? (b._id || b.id) : b;
          if (!bid) return false;
          return !selected.includes(String(bid));
        });

        await Promise.allSettled([
          ...selected.map((branchId) =>
            axiosInstance.post("/doctor-branches", { doctorId, branchId, isActive: true })
          ),
          ...toDeactivate.map((m) => axiosInstance.delete(`/doctor-branches/${m._id || m.id}`)),
        ]);
      }

      setShowModal(false);
      clearDoctorPhoto();
      await fetchDoctors();
    } catch (err) {
      console.error(err);
      setError((err && err.response && err.response.data && err.response.data.error) || err.message || "Save failed");
    }
  }

  async function removeDoctor(id) {
    if (!window.confirm("Mark doctor as inactive?")) return;
    const doctorId = String(id);
    try {
      await axiosInstance.delete(`/doctors/${id}`);
      setDoctors((prev) =>
        prev.map((d) =>
          String(d._id || d.id) === doctorId
            ? { ...d, isActive: false }
            : d
        )
      );
      await fetchDoctors();
    } catch (err) {
      alert((err && err.response && err.response.data && err.response.data.error) || (err && err.message) || "Delete failed");
    }
  }

  async function activateDoctor(id) {
    const doctorId = String(id);
    try {
      await axiosInstance.put(`/doctors/${id}`, { isActive: true });
      setDoctors((prev) =>
        prev.map((d) =>
          String(d._id || d.id) === doctorId
            ? { ...d, isActive: true }
            : d
        )
      );
      await fetchDoctors();
    } catch (err) {
      alert((err && err.response && err.response.data && err.response.data.error) || (err && err.message) || "Activate failed");
    }
  }

  function openCreateBranch() {
    setEditingBranchId(null);
    setBranchError("");
    setBranchForm({ name: "", code: "", address: "", timezone: "Asia/Kolkata", isActive: true });
    setShowBranchModal(true);
  }

  function openEditBranch(b) {
    setEditingBranchId(b._id || b.id);
    setBranchError("");
    setBranchForm({
      name: b.name || "",
      code: b.code || "",
      address: b.address || "",
      timezone: b.timezone || "Asia/Kolkata",
      isActive: typeof b.isActive === "undefined" ? true : !!b.isActive,
    });
    setShowBranchModal(true);
  }

  async function submitBranchForm() {
    setBranchError("");
    if (!branchForm.name || !branchForm.code) {
      setBranchError("Branch name and code are required");
      return;
    }
    try {
      if (editingBranchId) {
        await axiosInstance.put(`/branches/${editingBranchId}`, branchForm);
      } else {
        await axiosInstance.post("/branches", branchForm);
      }
      setShowBranchModal(false);
      await fetchBranches();
    } catch (err) {
      setBranchError((err && err.response && err.response.data && err.response.data.error) || err.message || "Save failed");
    }
  }

  async function deactivateBranch(id) {
    if (!window.confirm("Deactivate this branch?")) return;
    const branchId = String(id);
    try {
      await axiosInstance.delete(`/branches/${id}`);
      setBranchList((prev) =>
        prev.map((b) =>
          String(b._id || b.id) === branchId
            ? { ...b, isActive: false }
            : b
        )
      );
      await fetchBranches();
    } catch (err) {
      alert((err && err.response && err.response.data && err.response.data.error) || (err && err.message) || "Deactivate failed");
    }
  }

  async function activateBranch(id) {
    const branchId = String(id);
    try {
      await axiosInstance.put(`/branches/${id}`, { isActive: true });
      setBranchList((prev) =>
        prev.map((b) =>
          String(b._id || b.id) === branchId
            ? { ...b, isActive: true }
            : b
        )
      );
      await fetchBranches();
    } catch (err) {
      alert((err && err.response && err.response.data && err.response.data.error) || (err && err.message) || "Activate failed");
    }
  }
  return (
    <div className="settings-page">
      <Header branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />

     

      {/* Page Title */}
      <div className="settings-header">
        <h1>System Settings</h1>
        <p>Manage branches and doctor profiles for branch-wise admin flow.</p>
      </div>

      {/* Main Content */}
      <div className="settings-content">
        {/* Sidebar */}
        <div className="settings-sidebar">
          <div className={`sidebar-item ${activeTab === "doctors" ? "active" : ""}`} onClick={() => setActiveTab("doctors")}>
            <FaUserMd />
            Doctor Profiles
          </div>

          <div className={`sidebar-item ${activeTab === "branches" ? "active" : ""}`} onClick={() => setActiveTab("branches")}>
            <MdOutlineMedicalServices />
            Branch Master
          </div>

          {isAdminUser(user) && (
            <div
              className={`sidebar-item ${activeTab === "staff" ? "active" : ""}`}
              onClick={() => setActiveTab("staff")}
            >
              <FaUsers />
              Staff &amp; logins
            </div>
          )}
        </div>

        {/* Right Panel */}
        <div className="settings-panel">
          {activeTab === "staff" && isAdminUser(user) ? (
            <>
              <div className="panel-header">
                <div>
                  <h2>Staff &amp; logins</h2>
                  <p>Create doctor and staff accounts and set module permissions.</p>
                </div>
              </div>
              <AdminStaffPanel />
            </>
          ) : activeTab === "doctors" ? (
            <>
              <div className="panel-header">
                <div>
                  <h2>Doctor Profiles</h2>
                  <p>Add or modify doctors associated with the clinic.</p>
                </div>
                <button className="add-doctor-btn" onClick={openCreate}>+ Add New Doctor</button>
              </div>
              <div className="doctors-list">
                {loading ? (
                  <div>Loading...</div>
                ) : doctors.length === 0 ? (
                  <div>No doctors yet.</div>
                ) : (
                  doctors.map((d) => (
                    <div className="doctor-card1" key={d._id || d.id}>
                      <div className="doctor-info1">
                        <div className="avatar-wrapper">
                          <div className="doctor-avatar" aria-label="Doctor avatar">
                            {doctorPhotoUrl(d) ? (
                              <img src={doctorPhotoUrl(d)} alt="" className="doctor-avatar-img" />
                            ) : (
                              String(d.name || "D")
                                .trim()
                                .split(/\s+/)
                                .map((n) => n[0])
                                .join("")
                                .slice(0, 2)
                                .toUpperCase()
                            )}
                          </div>
                          <span className={`status-dot ${d.isActive ? "active" : "inactive"}`}></span>
                        </div>
                        <div>
                          <h3>{d.name} {d.isAdmin && <span className="admin-badge">ADMIN</span>}</h3>
                          <p>{d.specialty || "—"} {d.licenseNumber ? `· ${d.licenseNumber}` : ""}</p>
                          <p className="muted">{d.email || ""} {d.phone ? `· ${d.phone}` : ""}</p>
                        </div>
                      </div>
                      <div className="doctor-actions">
                        <button className="small-btn" onClick={() => openEdit(d)}>Edit</button>
                        {d.isActive ? (
                          <button className="small-btn danger" onClick={() => removeDoctor(d._id || d.id)}>Deactivate</button>
                        ) : (
                          <button className="small-btn" onClick={() => activateDoctor(d._id || d.id)}>Activate</button>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <>
              <div className="panel-header">
                <div>
                  <h2>Branch Master</h2>
                  <p>Select active branch in header dropdown to run branch-scoped flow.</p>
                </div>
                <button className="add-doctor-btn" onClick={openCreateBranch}>+ Add New Branch</button>
              </div>
              <div className="doctors-list">
                {branchLoading ? (
                  <div>Loading branches...</div>
                ) : branchList.length === 0 ? (
                  <div>No branches found.</div>
                ) : (
                  branchList.map((b) => {
                    const branchId = b._id || b.id;
                    const isSelected = branchId === selectedBranchId;
                    return (
                      <div className="doctor-card1" key={branchId}>
                        <div className="doctor-info1">
                          <div>
                            <h3>
                              {b.name} ({b.code || "NA"}){" "}
                              {isSelected && <span className="admin-badge">SELECTED</span>}
                            </h3>
                            <p>{b.address || "No address"} {b.timezone ? `· ${b.timezone}` : ""}</p>
                            <p className="muted">{b.isActive ? "Active" : "Inactive"}</p>
                          </div>
                        </div>
                        <div className="doctor-actions">
                          <button className="small-btn" onClick={() => onBranchChange && onBranchChange(branchId)}>Use</button>
                          <button className="small-btn" onClick={() => openEditBranch(b)}>Edit</button>
                          {b.isActive ? (
                            <button className="small-btn danger" onClick={() => deactivateBranch(branchId)}>Deactivate</button>
                          ) : (
                            <button className="small-btn" onClick={() => activateBranch(branchId)}>Activate</button>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </>
          )}

          {/* Modal for create/edit */}
          {showModal && (
            <div
              className="modal-overlay"
              onClick={() => {
                clearDoctorPhoto();
                setShowModal(false);
              }}
            >
              <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <h3>{editingId ? "Edit doctor" : "Create doctor"}</h3>
                {error && <div className="form-error">{error}</div>}
                <div className="form-grid">
                  <input
                    placeholder="Full name"
                    value={form.name}
                    onChange={(e)=>setForm({...form, name: e.target.value.replace(/[^A-Za-z ]/g, "")})}
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={(e)=>setForm({...form, email: e.target.value})}
                  />
                  <input
                    placeholder="Phone"
                    maxLength={10}
                    inputMode="numeric"
                    value={form.phone}
                    onChange={(e)=>setForm({...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10)})}
                  />
                  <input
                    placeholder="Specialty (comma separated)"
                    value={form.specialty}
                    onChange={(e)=>setForm({...form, specialty: e.target.value.replace(/[^A-Za-z, ]/g, "")})}
                  />
                  <input placeholder="License number" value={form.licenseNumber} onChange={(e)=>setForm({...form, licenseNumber: e.target.value})} />
                  <div className="branch-multiselect" style={{ gridColumn: "1 / -1" }}>
                    <div style={{ fontWeight: 700, marginBottom: 8 }}>Branches</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
                      {(branchList && branchList.length ? branchList : branches).map((b) => {
                        const bid = String(b._id || b.id);
                        const checked = Array.isArray(form.branchIds) && form.branchIds.map(String).includes(bid);
                        return (
                          <label key={bid} className="checkbox-inline" style={{ margin: 0 }}>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={(e) => {
                                const next = new Set((form.branchIds || []).map(String));
                                if (e.target.checked) next.add(bid);
                                else next.delete(bid);
                                setForm({ ...form, branchIds: Array.from(next) });
                              }}
                            />
                            {b.name || bid}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                  <label className="checkbox-inline"><input type="checkbox" checked={!!form.isActive} onChange={(e)=>setForm({...form, isActive: e.target.checked})} /> Active</label>
                </div>
                <div className="doctor-photo-upload">
                  <label className="doctor-photo-label">Profile photo (optional)</label>
                  <div className="doctor-photo-row">
                    <div className="doctor-photo-preview-wrap" aria-hidden="true">
                      {doctorPhotoPreview ? (
                        <img src={doctorPhotoPreview} alt="" className="doctor-photo-preview-img" />
                      ) : (
                        <span className="doctor-photo-placeholder">No image</span>
                      )}
                    </div>
                    <div className="doctor-photo-actions">
                      <input
                        ref={doctorPhotoInputRef}
                        type="file"
                        accept="image/jpeg,image/png,image/webp,image/gif"
                        className="doctor-photo-input"
                        onChange={(e) => {
                          const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
                          if (!file) return;
                          if (!file.type.startsWith("image/")) {
                            setError("Please choose an image file (JPEG, PNG, WebP, or GIF).");
                            return;
                          }
                          const max = 5 * 1024 * 1024;
                          if (file.size > max) {
                            setError("Image must be 5 MB or smaller.");
                            return;
                          }
                          setError("");
                          if (doctorPhotoPreview && doctorPhotoPreview.startsWith("blob:")) {
                            URL.revokeObjectURL(doctorPhotoPreview);
                          }
                          setDoctorPhotoFile(file);
                          setDoctorPhotoPreview(URL.createObjectURL(file));
                        }}
                      />
                      <button
                        type="button"
                        className="small-btn"
                        onClick={() => doctorPhotoInputRef.current && doctorPhotoInputRef.current.click()}
                      >
                        Choose image
                      </button>
                      {(doctorPhotoFile || (doctorPhotoPreview && doctorPhotoPreview.startsWith("blob:"))) && (
                        <button
                          type="button"
                          className="small-btn"
                          onClick={() => {
                            clearDoctorPhoto();
                          }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                  <p className="doctor-photo-hint">
                    Optional. Max 5 MB. When you save, the image is sent as <code>photoBase64</code> (data URL) for your backend to upload to S3.
                  </p>
                </div>
                <div className="form-actions" style={{marginTop:12}}>
                  <button
                    className="cancel-btn"
                    onClick={() => {
                      clearDoctorPhoto();
                      setShowModal(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="create-btn" onClick={submitForm}>{editingId ? "Update" : "Create"}</button>
                </div>
              </div>
            </div>
          )}
          {showBranchModal && (
            <div className="modal-overlay" onClick={() => setShowBranchModal(false)}>
              <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <h3>{editingBranchId ? "Edit branch" : "Create branch"}</h3>
                {branchError && <div className="form-error">{branchError}</div>}
                <div className="form-grid">
                  <input placeholder="Branch name" value={branchForm.name} onChange={(e)=>setBranchForm({...branchForm, name: e.target.value})} />
                  <input placeholder="Branch code" value={branchForm.code} onChange={(e)=>setBranchForm({...branchForm, code: e.target.value})} />
                  <input placeholder="Address" value={branchForm.address} onChange={(e)=>setBranchForm({...branchForm, address: e.target.value})} />
                  <input placeholder="Timezone (e.g. Asia/Kolkata)" value={branchForm.timezone} onChange={(e)=>setBranchForm({...branchForm, timezone: e.target.value})} />
                  <label className="checkbox-inline"><input type="checkbox" checked={!!branchForm.isActive} onChange={(e)=>setBranchForm({...branchForm, isActive: e.target.checked})} /> Active</label>
                </div>
                <div className="form-actions" style={{marginTop:12}}>
                  <button className="cancel-btn" onClick={()=>setShowBranchModal(false)}>Cancel</button>
                  <button className="create-btn" onClick={submitBranchForm}>{editingBranchId ? "Update" : "Create"}</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
